import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  styleUrls: ['./tab-navigation.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class TabNavigationComponent {
  @Input()
  navigationItems!: NavigationItem[];
}

export type NavigationItem = {
  label: string;
  url: string;
};
